import { Volume2 } from 'lucide-react';

export const NoteButton = ({ testId, label, sub, corner, compact, active, target, onClick }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`relative h-14 w-full min-w-0 sm:min-w-[3.25rem] px-1 sm:px-3 rounded-xl border flex flex-col items-center justify-center font-bebas tracking-wide active:scale-95 transition-[transform,background-color,border-color,box-shadow] ${
      active
        ? 'bg-pink-400 text-black border-pink-400 shadow-[0_0_20px_rgba(236,72,153,0.5)]'
        : target
          ? 'border-emerald-400/70 text-emerald-300 bg-emerald-400/10'
          : 'border-white/10 text-white/80 hover:border-white/30'
    }`}
  >
    <span className="text-2xl leading-none">{label}</span>
    {sub && <span className="text-[9px] font-mono whitespace-nowrap opacity-60 mt-0.5">{sub}</span>}
    {corner && <span className={`absolute top-1 left-1.5 text-[9px] font-mono opacity-50 ${compact ? 'hidden sm:block' : ''}`}>{corner}</span>}
    {active && <Volume2 className="absolute top-1 right-1 w-3 h-3" />}
  </button>
);

export const Panel = ({ title, testId, cols, header, children }) => (
  <section data-testid={testId} className="bg-[#111112] border border-white/5 rounded-2xl p-4 sm:p-6">
    <div className="text-[10px] uppercase tracking-[0.3em] text-white/45 mb-3">{title}</div>
    {header}
    <div
      className={cols ? 'grid gap-1.5 sm:gap-2' : 'flex flex-wrap gap-2'}
      style={cols ? { gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` } : undefined}
    >
      {children}
    </div>
  </section>
);

export const nearestIndex = (notes, detected) => (detected === null ? -1
  : notes.reduce((best, m, i) => (Math.abs(m - detected) < Math.abs(notes[best] - detected) ? i : best), 0));
